/**
 * Rounds a number to the given number of decimals
 * @param {number} number
 * @param {number} decimals
 * @returns {number} The rounded number
 */
export default function mathRound(number, decimals = 1) {
  const roundFactor = 10 ** decimals

  return Math.round(number * roundFactor) / roundFactor
}
